/**
 * View component for /user-evaluations/:userEvaluationId
 *
 * Displays a single userEvaluation from the 'byId' map in the userEvaluation reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as userEvaluationActions from '../userEvaluationActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import userEvaluation components
import UserEvaluationLayout from '../components/UserEvaluationLayout.js.jsx';

// import userEvaluation css modules
import userEvaluationStyles from '../userEvaluationModuleStyles.css';


class SingleUserEvaluation extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(userEvaluationActions.fetchSingleIfNeeded(match.params.userEvaluationId));
  }

  render() {
    const { userEvaluationStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual userEvaluation object from the map
     */
    const selectedUserEvaluation = userEvaluationStore.selected.getItem();

    const isEmpty = (
      !selectedUserEvaluation
      || !selectedUserEvaluation._id
      || userEvaluationStore.selected.didInvalidate
    );

    return (
      <UserEvaluationLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h3> Single User Evaluation </h3>
              {isEmpty ?
                (userEvaluationStore.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: userEvaluationStore.isFetching ? 0.5 : 1 }}>
                  <h1> { selectedUserEvaluation.name }
                    <Link className="yt-btn small u-pullRight" to={`${this.props.match.url}/update`}> UPDATE User Evaluation </Link>
                  </h1>
                  <hr/>
                  <p> <em>Other characteristics about the UserEvaluation would go here.</em></p>
                </div>
              }
            </div>
          </section>
        </div>
      </UserEvaluationLayout>
    )
  }
}

SingleUserEvaluation.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    userEvaluationStore: store.userEvaluation
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleUserEvaluation)
);



// WEBPACK FOOTER //
// modules/userEvaluation/views/SingleUserEvaluation.js.jsx